import { DeviceEdgeModuleDto, Equipment, IDeviceEdgeModuleDto, ISiteSetupDTO, SiteSetupDTO } from 'shared/api/api';
import { AsyncOperationBuilder2 } from 'shared/helpers/redux-helpers';
import * as Action from './actions';

export const GetDeviceProxyProperties = (edgeModule: IDeviceEdgeModuleDto) => {
	const dto = DeviceEdgeModuleDto.fromJS({});
	dto.init(edgeModule);
	return AsyncOperationBuilder2(
		Action.getDeviceProxyPropertiesAsync,
		client => client.iotHub_GetDeviceProxyProperties(dto),
		dto,
	);
};

export const SetDeviceProxyProperties = (edgeModule: IDeviceEdgeModuleDto) => {
	const dto = DeviceEdgeModuleDto.fromJS({});
	dto.init(edgeModule);
	return AsyncOperationBuilder2(
		Action.setDeviceProxyPropertiesAsync,
		client => client.iotHub_SetDeviceProxyProperties(dto),
		dto,
	);
};

export const GetDeviceEdgeAgentProperties = (deviceId: string, equipment: Equipment) => {
	return AsyncOperationBuilder2(
		Action.getDeviceEdgeAgentPropertiesAsync,
		client => client.iotHub_GetDeviceEdgeAgentProperties(deviceId, equipment),
		{ deviceId, equipment },
	);
};

export const GetDeviceConnectionString = (deviceId: string, equipment: Equipment) => {
	return AsyncOperationBuilder2(
		Action.getDeviceConnectionStringAsync,
		client => client.iotHub_GetDeviceConnectionString(deviceId, equipment),
		{ deviceId, equipment },
	);
};
